import { $t } from "~/i18n";
import { formatDateTime } from "~/utils/format";
import { FieldValue, Field } from "~/entities/customer";

export const CustomersHelper = {
  getFieldName: (field: Field) => {
    if (field.name === "phone") return $t("customers.nick");
    if (field.type === "customer") return $t(`customers.${field.name}`);

    return field.name;
  },
  getValue: (field: Field, fieldValue?: FieldValue) => {
    if (!fieldValue) {
      return "";
    }

    if (["date", "bDate"].includes(field.type || "")) {
      return fieldValue.invalid
        ? fieldValue.value
        : formatDateTime(fieldValue.value.substring(0, 10));
    }

    if (field.type === "phone" && fieldValue.value.length === 0) {
      return "—";
    }

    return fieldValue.value;
  },
};

export const customerConstants = Object.freeze({
  DEFAULT_FILTER_DEBOUNCE: 1000,
  FILTER_DATE_FORMAT: "YYYY-MM-DD",
  FILTER_DATE_DISPLAY_FORMAT: "DD.MM.YYYY",
});

export const systemFields: Field[] = [
  {
    id: 'status',
    order: 2,
    name: 'status',
    type: 'customer',
  },
  {
    id: 'uploadMethod',
    order: 2,
    name: 'uploadMethod',
    type: 'customer',
  },
  {
    id: 'createdAt',
    order: 3,
    name: 'Дата загрузки',
    type: 'date',
  },
  {
    id: 'dispatchedAt',
    order: 6,
    name: 'Последняя рассылка',
    type: 'date',
  },
  {
    id: 'updatedAt',
    order: 7,
    name: 'Дата изменения',
    type: 'date',
  },
];

const sortedListNameSystemColumn: string[] = ['phone', "Telegram", "Имя", 'status', "uploadMethod", 'Дата загрузки', 'Дата изменения', 'Последняя рассылка', "Тег", "Дата рождения"]

export const sortedSystemFields = (fields: Field[]) => {
  const otherFields: Field[] = []
  const systemFields: Field[] = []
  fields.forEach(field => {
    if(sortedListNameSystemColumn.includes(field.name)){
      const inrexField = sortedListNameSystemColumn.indexOf(field.name)
      systemFields[inrexField] = field
    } else {
      otherFields.push(field)
    }
  })
  const sortedFields = [...systemFields, ...otherFields].filter(field  => field)

  return sortedFields
}
